import { useState } from "react"

export const ReportState = () => {
   
    const [bsreport, setBSReport] = useState([
        {id:1, bkng_number: "BKNG-000001", bkng_date: "11/7/2023", bkng_time: "6:00 AM - 5:00PM", name: "Laarni Amistad Morada", payment_ref_number: "BSAANDLJAVKSFN", payment_channel: "Gcash", bkng_status: "Booked",  payment_status: "Paid",  total_amount: "₱ 1,360" },
        {id:2, bkng_number: "BKNG-000002", bkng_date: "11/8/2023", bkng_time: "6:00 AM - 5:00PM", name: "Laarni Amistad Morada", payment_ref_number: "BSAANDLJAVKSFN", payment_channel: "Gcash", bkng_status: "Check Out",  payment_status: "Paid",  total_amount: "₱ 1,360" },
        {id:3, bkng_number: "BKNG-000003", bkng_date: "11/9/2023", bkng_time: "6:00 AM - 5:00PM", name: "Laarni Amistad Morada", payment_ref_number: "BSAANDLJAVKSFN", payment_channel: "Gcash", bkng_status: "Check In",  payment_status: "Paid",  total_amount: "₱ 1,360" }
])



const [lpform, setLPForm] = useState({
    branch: {value:'', msg:'', stat:false },
    from: {value:'', msg:'', stat:false },
    to: {value:'', msg:'', stat:false }
})

const [psrdata, setPRSData] = useState([]);
const [inftScroll, setInftScroll] = useState(true)
const [lid, setLid] = useState(0)
const [limit] = useState(10)
const [loadData, setLoadData] = useState(false)
const [isLoader, setIsLoader] = useState(false)
const [refName, setRefName] = useState('per branch')
const [pointsData, setPointsData] = useState([])




   const [reportbtn, setReportBtn] = useState();
   const [genreport, setGenReport] = useState({revenue:'',total_bookings:'',total_checkin:'',total_checkout:''});
   const [vcount, setVcount] = useState(0)
    return { 
        bsreport: { data: bsreport, set: setBSReport },
        reportbtn: { data: reportbtn, set: setReportBtn },
        genreport: { data: genreport, set: setGenReport },

        psrdata: {data: psrdata, set: setPRSData },
        inftScroll: {data: inftScroll, set: setInftScroll},
        lpform: {data: lpform, set: setLPForm },
        lid: {data: lid, set: setLid },
        limit: {data: limit },
        loadData: {data: loadData, set: setLoadData },
        isLoader: {data: isLoader, set: setIsLoader },
        refName: {data: refName, set: setRefName },
        pointsData: {data: pointsData, set: setPointsData },
        vcount: {data: vcount, set: setVcount}
      
    }
}